import { IGraduatedPrice } from '@cbgms/api'
import Currency from '@cbgms/components/general/Currency'
import { Box, CircularProgress, Popover } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ArrowIcon from '@mui/icons-material/ArrowDropDown'
import PriceTableCell from './PriceTableCell'
import { LocaleContext } from '@cbgms/base/locale/LocaleContext'
import React from 'react'

interface Props {
  graduatedPrices?: IGraduatedPrice[]
  hideLabels?: boolean
  onlyLabels?: boolean
}

export const FromPriceNew: React.FC<{
  open: boolean
  loading: boolean
  handleClick: (event: React.MouseEvent<HTMLElement>) => void
  handleClose: () => void
  anchorEl: HTMLElement | null
  graduatedPrices?: IGraduatedPrice[]
  hideLabels?: boolean
  onlyLabels?: boolean
}> = ({ children, open, loading, handleClick, handleClose, anchorEl, graduatedPrices, hideLabels, onlyLabels }) => {
  const { t } = useTranslation()
  const { formatter } = React.useContext(LocaleContext)
  if (!graduatedPrices?.length) return null

  const priceList = graduatedPrices.map((prices: { Price: number }) => prices.Price)
  const lowestPrice = Math.min(...priceList)
  // const formattedAmount = formatter.format(lowestPrice || 0)
  const parts = formatter.formatToParts(lowestPrice || 0)
  const currencyPart = parts.find((p: any) => p.type === 'currency')?.value || ''
  const numberPart = parts
    .filter((p: any) => p.type !== 'currency')
    .map((p: any) => p.value)
    .join('')

  return (
    <>
      <tr style={{ color: '#005596' }} onClick={handleClick}>
        {!hideLabels && (
          <PriceTableCell style={{ float: 'right', display: 'flex', alignItems: 'center' }}>
            <Box height='100%' width='100%' sx={{ position: 'relative' }}>
              {loading ? <CircularProgress size='1rem' /> : <ArrowIcon data-testid='graduated-price-down-arrow-icon' />}
            </Box>
            {t('product.from_price')}:
          </PriceTableCell>
        )}
        {!onlyLabels && (
          <>
            <PriceTableCell style={{ paddingLeft: '10px' }}>{currencyPart}</PriceTableCell>
            <PriceTableCell style={{ paddingLeft: '10px' }}>{numberPart}</PriceTableCell>
          </>
        )}
      </tr>
      <Popover
        data-testid='graduated-prices-popover'
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        onClose={handleClose}
      >
        {children}
      </Popover>
    </>
  )
}

export function FromPrice({ graduatedPrices, onlyLabels = false, hideLabels = false }: Props) {
  const { t } = useTranslation()
  if (!graduatedPrices?.length) return null

  const priceList = graduatedPrices.map(prices => prices.Price)
  const lowestPrice = Math.min(...priceList)

  return (
    <tr>
      {!hideLabels && <td>{t('product.from_price')}</td>}
      {!onlyLabels && (
        <td>
          <Currency amount={lowestPrice} />
        </td>
      )}
    </tr>
  )
}
